import './styles/colors-viewer.scss';